import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Droplets, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';
import { toast } from 'sonner';

function AguaLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [nome, setNome] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/agua/auth/login', { username, password });
      localStorage.setItem('agua_token', data.access_token);
      localStorage.setItem('agua_user', JSON.stringify(data.user));
      toast.success('Login realizado com sucesso!');
      navigate('/agua/admin');
    } catch (error) {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/agua/auth/register', { username, password, nome });
      toast.success('Usuário criado! Faça login.');
      setIsRegister(false);
      setNome('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao criar usuário');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-900 via-cyan-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 shadow-2xl">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-2xl mx-auto flex items-center justify-center mb-4 shadow-lg">
              <Droplets className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">LJ Águas</h1>
            <p className="text-cyan-200">Sistema de Fidelidade</p>
          </div>

          {/* Form */}
          <form onSubmit={isRegister ? handleRegister : handleLogin} className="space-y-4">
            {isRegister && (
              <div>
                <Label className="text-cyan-100 text-sm">Nome</Label>
                <Input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
                  placeholder="Seu nome"
                  required
                />
              </div>
            )}
            <div>
              <Label className="text-cyan-100 text-sm">Usuário</Label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
                placeholder="Digite seu usuário"
                required
              />
            </div>
            <div>
              <Label className="text-cyan-100 text-sm">Senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
                placeholder="Digite sua senha"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white font-medium py-6"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : isRegister ? (
                'Criar Conta'
              ) : (
                'Entrar'
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => setIsRegister(!isRegister)}
              className="text-cyan-300 hover:text-white text-sm transition-colors"
            >
              {isRegister ? 'Já tem conta? Fazer login' : 'Criar nova conta'}
            </button>
          </div>
        </div>

        <p className="text-center text-cyan-300/50 text-xs mt-6">
          Sistema de Cartão Fidelidade Digital
        </p>
      </div>
    </div>
  );
}

export default AguaLogin;
